import api from '@/api/axios/auth.api'

export const login = (data) => {
  return api.post('/auth/login', data)
}

export const refresh_token = (data) => {
  return api.post('/auth/token/refresh', data)
}
